import PersonalApiKeysManagedUsersCallout from "components/ApiKeys/PersonalApiKeys/ManagedUsersCallout";
import usePersonalApiKeysTableSort from "components/ApiKeys/PersonalApiKeys/Table/useSort";
import usePersonalApiKeysState from "components/ApiKeys/PersonalApiKeys/usePersonalApiKeysState";
import ListContentWrapper from "components/ListContentWrapper";
import PageLoading from "components/loading/PageLoading";
import TableSimple from "ds/components/TableSimple";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import useErrorHandle from "hooks/useErrorHandle";
import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";

import { SettingsContext } from "../../Context";
import { UserManagementActivationStatus } from "../../types";
import ApiKeysPageLayout from "../PageLayout";
import ApiKeysPersonalEmpty from "./Empty";
import { ApiKeysPersonalEmptyVariant } from "./Empty/types";
import { API_KEYS_PERSONAL_TABLE_CELLS } from "./Table/Cells";
import {
  API_KEYS_PERSONAL_FILTERS_ORDER_KEY,
  API_KEYS_PERSONAL_INITIAL_SORT,
  API_KEYS_PERSONAL_SORT_CONFIG,
  API_KEYS_PERSONAL_SORT_FIELDS,
} from "./Table/constants";
import useApiKeysPersonalTableStore from "./Table/useTableStore";
import useApiKeysPersonalData from "./useData";

const ApiKeysPersonal = () => {
  const { accountName } = useTypedContext(AccountContext);
  const { activationStatus } = useTypedContext(SettingsContext);

  useTitle(`Organization Settings · API keys · Personal · ${accountName}`);

  const { apiKeys, isInitialLoading, error } = useApiKeysPersonalData();
  const sortedApiKeys = usePersonalApiKeysTableSort(
    apiKeys,
    API_KEYS_PERSONAL_SORT_FIELDS,
    API_KEYS_PERSONAL_INITIAL_SORT
  );
  const { enabled: isPersonalApiKeysEnabled } = usePersonalApiKeysState();

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  if (isInitialLoading) {
    return <PageLoading />;
  }

  const hasApiKeys = apiKeys.length > 0;
  const isManagedUsersActive = activationStatus === UserManagementActivationStatus.ACTIVE;

  return (
    <ApiKeysPageLayout>
      {!isManagedUsersActive && (
        <PersonalApiKeysManagedUsersCallout
          analyticsPage={AnalyticsPageOrganization.OrganizationApiKeys}
        />
      )}
      <ListContentWrapper>
        {hasApiKeys && (
          <TableSimple
            data={sortedApiKeys}
            store={useApiKeysPersonalTableStore}
            ariaLabel="Personal API keys table"
            cellPerColumn={API_KEYS_PERSONAL_TABLE_CELLS}
            sortConfig={API_KEYS_PERSONAL_SORT_CONFIG}
            filtersStorageKey={API_KEYS_PERSONAL_FILTERS_ORDER_KEY}
            hideSettings
            hasPagination={false}
          />
        )}
        {!hasApiKeys && (
          <ApiKeysPersonalEmpty
            variant={
              isPersonalApiKeysEnabled
                ? ApiKeysPersonalEmptyVariant.NO_KEYS
                : ApiKeysPersonalEmptyVariant.TURNED_OFF
            }
          />
        )}
      </ListContentWrapper>
    </ApiKeysPageLayout>
  );
};

export default ApiKeysPersonal;
